//Below api is uncommented for local, it used for local
//export const API_BASE_URL = "http://localhost:9090";
//export const API_PREFIX = "";
//Below api is commented for production, it used for production
export const API_BASE_URL =  process.env.REACT_APP_API_BASE_URL || "";
export const API_PREFIX = "/api";
// API Endpoints
export const API_ENDPOINTS = {
  LOGIN: "/auth/login",
  LOGOUT: "/auth/logout",
  SIGNUP: "/registration",
  PROFILE: "/users/profile",
  UPDATE_PROFILE: (mobileNo) => `/users/personal-details/${mobileNo}`,
  UPDATE_USER: (perDId) => `/users/${perDId}`,
  SEARCH_USERS: "/users/search",
  ADMIN_ALL_USERS: "/admin/users/all",
  REFRESH_TOKEN: "/auth/refresh",
  CREATE_ORDER: "/order/place",
  SEARCH_ORDERS: "/order/search",
  PRODUCT_SALES_REPORT: "/order/report/product-sales",
  GST_REPORT: "/order/report/gst",
  GST_REPORT_PDF: "/order/report/gst/pdf",
  GST_REPORT_EXCEL: "/order/report/gst/excel",
  PENDING_PAYMENTS: "/order/payments/pending",
  COLLECT_PAYMENT: "/order/payments/collect",
  PAYMENT_REPORT_PDF: "/order/payments/report/pdf",
  PAYMENT_REPORT_EXCEL: "/order/payments/report/excel",
  RETURN_ORDER: "/order/return",
  GET_RETURNS: (orderId) => `/order/return/${orderId}`,
  GET_ORDER_DETAIL: (orderId) => `/order/${orderId}`,
  CANCEL_ORDER: (orderId) => `/order/${orderId}/cancel`,
  SEARCH_CUSTOMERS: "/order/customers/search",
  CUSTOMER_PROFILE: (mobile) => `/order/customers/${mobile}`,
  CUSTOMER_ORDERS: (mobile) => `/order/customers/${mobile}/orders`,
  STOCK_REPORT_PDF: "/stock/report/pdf",
  STOCK_REPORT_EXCEL: "/stock/report/excel",
  DISTRIBUTOR_REPORT_PDF: "/audit/v1/distributors/pdf",
  DISTRIBUTOR_REPORT_EXCEL: "/audit/v1/distributors/excel",
  DISTRIBUTOR_BILL_REPORT_PDF: "/audit/v1/distributors/bills/pdf",
  DISTRIBUTOR_BILL_REPORT_EXCEL: "/audit/v1/distributors/bills/excel",

  // Product endpoints
  CREATE_PRODUCT: "/stock/product",
  SEARCH_PRODUCT_BY_NAME: (name, productType, manufacturer) => {
  const params = new URLSearchParams();

  params.append("name", name);
if (productType && productType.trim() !== "") {
    params.append("productType", productType.trim());
  }
  if (manufacturer && manufacturer.trim() !== "") {
    params.append("manufacturer", manufacturer.trim());
  }

  return `/stock/product/search?${params.toString()}`;
},

  // Stock endpoints
  CREATE_STOCK: "/stock/",
  SEARCH_STOCK: "/stock/search",
  STOCK_VALIDATE: "/stock/validate",
  STOCK_RELEASE: "/stock/reserve/release",
  DASHBOARD: "/notification/dashboard",
  CLIENT_FIELD_CONFIG: "/notification/field/config",
  UPLOAD_CLIENT_LOGO: "/users/client/logo",
  GET_CLIENT_LOGO: "/users/client/logo",
  CLIENT_INVOICE_ADDRESS: "/users/client/invoice-address",
  BILLING_STATUS: "/notification/billing/status",
  SEARCH_STOCK_PAGINATED: (name) =>
    `/stock/availability/${encodeURIComponent(name)}`,
  UPDATE_STOCK: "/stock/",
  DELETE_STOCK: (stockId) => `/stock/${stockId}`,
  STOCK_HISTORY: (stockId) => `/stock/${stockId}/history`,

  // Distributor endpoints
  GET_DISTRIBUTOR_BY_MOBILE: "/audit/v1/distributors/mobile",
  GET_DISTRIBUTOR_WITH_BILL: "/audit/v1/distributors/bills/with-distributor",
  CREATE_DISTRIBUTOR: "/audit/v1/distributors/create",
  SEARCH_DISTRIBUTORS: "/audit/v1/distributors/search",
  UPDATE_DISTRIBUTOR: "/audit/v1/distributors/update",
  DELETE_DISTRIBUTOR: "/audit/v1/distributors/delete",
  CREATE_DISTRIBUTOR_BILL: "/audit/v1/distributors/bills/create",
  SEARCH_DISTRIBUTOR_BILLS: "/audit/v1/distributors/bills/search",
  UPDATE_DISTRIBUTOR_BILL: "/audit/v1/distributors/bills/update",
  DELETE_DISTRIBUTOR_BILL: "/audit/v1/distributors/bills/delete",
  CREATE_BILL_WITH_DISTRIBUTOR:
    "/audit/v1/distributors/create-with-distributor",

  // AI chatbot. Gateway routes /ai/** (local) and /api/ai/** (prod) to the
  // Python AI service, which sees /v1/chat after the prefix is stripped.
  AI_CHAT: "/ai/v1/chat",

  // AI bulk stock extraction (reads an uploaded receipt into structured rows).
  // Read-only: the AI never creates data; the Stock Create page still saves.
  AI_EXTRACT_STOCK: "/ai/v1/extract-stock",

  // Per-client feature flag for the chatbot (Notification Service).
  CHATBOT_ENABLED: "/notification/dashboard/settings/chatbot-enabled",
  GST_REPORT_ENABLED: "/notification/dashboard/settings/gst-report-enabled",
  WHATSAPP_BILL_ENABLED: "/notification/dashboard/settings/whatsapp-bill-enabled",

  // Offers (Notification Service).
  OFFER_CHANNEL: "/notification/dashboard/settings/offer-channel",
  OFFERS: "/notification/offers",
  OFFERS_SEND: "/notification/offers/send",
  OFFERS_HISTORY: "/notification/offers/history",
  OFFERS_TITLES: "/notification/offers/titles",
  OFFERS_ITEMS: "/notification/offers/items",
  OFFERS_ITEM_FILTERS: "/notification/offers/item-filters",

  // WhatsApp Cloud API onboarding (Embedded Signup) per client.
  WHATSAPP_CONFIG: "/notification/whatsapp/config",
  WHATSAPP_CONNECT: "/notification/whatsapp/connect",
  WHATSAPP_TEMPLATE: "/notification/whatsapp/template",
  WHATSAPP_DISCONNECT: "/notification/whatsapp/disconnect",
};

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: "token",
  USERNAME: "userName",
  REFRESH_TOKEN: "refreshToken",
};

// Image Paths
export const IMAGE_PATHS = {
  DEFAULT_PROFILE: "/images/background.jpg",
  BACKGROUND: "/images/background.jpg",
};

// Pagination
export const PAGINATION = {
  PAGE_SIZE: 15,
};

// User Roles
export const USER_ROLES = {
  ADMIN: "admin",
  USER: "user",
};
